(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shop-button"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cf-shop-catalog')) {
  customElements.define('cf-shop-catalog', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.disclosure = this.closest('details');
      this.main = this.querySelector('.cf-catalog__main');
      this.pruneEmptyLinks();
      const firstCategory = Array.from(this.querySelectorAll('[data-category]')).find(tab => !tab.hidden);
      const firstFilter = Array.from(this.querySelectorAll('[data-yarn-tab]')).find(tab => !tab.hidden);
      if (firstCategory) this.activate('category', firstCategory.dataset.category);
      if (firstFilter) this.activate('yarn-tab', firstFilter.dataset.yarnTab);
      this.addEventListener('click', event => {
        const category = event.target.closest('[data-category]');
        const filter = event.target.closest('[data-yarn-tab]');
        if (category) this.activate('category', category.dataset.category);
        if (filter) this.activate('yarn-tab', filter.dataset.yarnTab);
        if (event.target.closest('[data-catalog-close]')) this.close();
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); this.close(); return; }
        const tab = event.target.closest('[role="tab"]');
        if (!tab) return;
        const list = tab.closest('[role="tablist"]');
        const tabs = Array.from(list.querySelectorAll('[role="tab"]')).filter(item => !item.hidden);
        const vertical = list.getAttribute('aria-orientation') === 'vertical';
        let index = tabs.indexOf(tab);
        if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = tabs.length - 1;
        else if (event.key === (vertical ? 'ArrowDown' : 'ArrowRight')) index = (index + 1) % tabs.length;
        else if (event.key === (vertical ? 'ArrowUp' : 'ArrowLeft')) index = (index - 1 + tabs.length) % tabs.length;
        else return;
        event.preventDefault(); tabs[index].click(); tabs[index].focus();
      }, options);
      this.disclosure.addEventListener('toggle', () => {
        if (this.disclosure.open) { requestAnimationFrame(() => this.resize()); this.loadFilterVisibility(); }
      }, options);
      this.disclosure.addEventListener('focusout', event => {
        if (event.relatedTarget && !this.disclosure.contains(event.relatedTarget)) this.disclosure.open = false;
      }, options);
      window.addEventListener('resize', () => { if (this.disclosure.open) this.resize(); }, options);
    }
    pruneEmptyLinks() {
      let collections;
      try { collections = JSON.parse(this.querySelector('[data-menu-collections]').textContent); }
      catch (_) { return; }
      for (const extra of this.filterCollections || []) {
        const item = collections.find(entry => entry.handle === extra.handle);
        if (item) item.filters = extra.filters;
      }
      const byHandle = new Map(collections.map(item => [item.handle, item]));
      const vendors = JSON.parse(this.querySelector('[data-menu-vendors]').textContent).map(value => value.trim().toLowerCase());
      const fiberGroups = {WV:['WV','WVR'],WS:['WS','WSR']};
      const isEmpty = anchor => {
        const url = new URL(anchor.href, location.origin);
        if (url.origin !== location.origin) return false;
        const handle = url.pathname.match(/\/collections\/([^/]+)/)?.[1];
        if (handle === 'vendors' && url.searchParams.has('q')) return !vendors.includes(url.searchParams.get('q').trim().toLowerCase());
        const collection = byHandle.get(handle);
        if (!collection) return false;
        if (collection.count === 0) return true;
        const nativeParams = Array.from(url.searchParams.entries()).filter(([key]) => key.startsWith('filter.') && !key.startsWith('filter.v.price.'));
        for (const [param,value] of nativeParams) {
          const option = collection.filters.find(item => item.param === param && String(item.value) === value);
          if (option && option.count === 0) return true;
        }
        const fiberRule = url.searchParams.get('cf_fc');
        if (fiberRule && !url.searchParams.has('cf_structure')) {
          const compositions = collection.filters.filter(item => /material[-_ ]composition/i.test(item.param));
          if (compositions.length) {
            const codes = new Set();
            compositions.filter(item => item.count > 0).forEach(item => {
              for (const match of item.label.matchAll(/(\d+(?:\.\d+)?)\s*([A-Za-z]+)/g)) if (Number(match[1]) > 0) codes.add(match[2].toUpperCase());
            });
            const code = fiberRule.split(':')[0].toUpperCase();
            if (!(fiberGroups[code] || [code]).some(item => codes.has(item))) return true;
          }
        }
        return false;
      };
      const links = Array.from(document.querySelectorAll('.cf-shop-disclosure a,.header__bottom a,.menu-drawer a'));
      for (const link of links) {
        if (!isEmpty(link)) continue;
        link.hidden = true; link.dataset.menuEmpty = 'true';
        const item = link.closest('li');
        if (item && !item.querySelector('ul')) { item.hidden = true; item.dataset.menuEmpty = 'true'; }
      }
      const hasLinks = panel => Array.from(panel.querySelectorAll('a')).some(link => !link.hidden && !link.closest('li[hidden]'));
      this.querySelectorAll('[data-yarn-panel]').forEach(panel => {
        if (!hasLinks(panel)) this.querySelector('[data-yarn-tab="' + panel.dataset.yarnPanel + '"]').hidden = true;
      });
      this.querySelectorAll('[data-panel]').forEach(panel => {
        if (!hasLinks(panel)) this.querySelector('[data-category="' + panel.dataset.panel + '"]').hidden = true;
      });
    }
    async loadFilterVisibility() {
      if (this.visibilityPromise) return this.visibilityPromise;
      const section = this.closest('.shopify-section');
      if (!section) return;
      const sectionId = section.id.replace(/^shopify-section-/, '');
      const base = JSON.parse(this.querySelector('[data-menu-collections]').textContent);
      const required = ['yarn','cones'].filter(handle => base.some(item => item.handle === handle && !item.filters.length));
      if (!required.length) return;
      const cacheKey = 'cf-menu-filter-visibility-v1:' + this.dataset.theme + ':' + this.dataset.locale;
      this.visibilityPromise = (async () => {
        let cached;
        try { cached = JSON.parse(sessionStorage.getItem(cacheKey)); } catch (_) {}
        if (cached && Date.now() - cached.time < 60000) this.filterCollections = cached.collections;
        else {
          const results = await Promise.all(required.map(async handle => {
            try {
              const url = new URL('/collections/' + handle, location.origin);
              url.searchParams.set('section_id', sectionId);
              const response = await fetch(url, {credentials:'same-origin'});
              if (!response.ok) return null;
              const html = await response.text();
              const doc = new DOMParser().parseFromString(html, 'text/html');
              const data = doc.querySelector('[data-menu-collections]');
              if (!data) return null;
              return JSON.parse(data.textContent).find(item => item.handle === handle && item.filters.length) || null;
            } catch (_) { return null; }
          }));
          this.filterCollections = results.filter(Boolean);
          if (this.filterCollections.length) try { sessionStorage.setItem(cacheKey, JSON.stringify({time:Date.now(),collections:this.filterCollections})); } catch (_) {}
        }
        this.pruneEmptyLinks();
        const category = this.querySelector('[data-category][aria-selected="true"]');
        if (category?.hidden) {
          const first = Array.from(this.querySelectorAll('[data-category]')).find(tab => !tab.hidden);
          if (first) this.activate('category', first.dataset.category);
        }
        const filter = this.querySelector('[data-yarn-tab][aria-selected="true"]');
        if (filter?.hidden) {
          const first = Array.from(this.querySelectorAll('[data-yarn-tab]')).find(tab => !tab.hidden);
          if (first) this.activate('yarn-tab', first.dataset.yarnTab);
        }
      })();
      return this.visibilityPromise;
    }
    activate(kind, value) {
      const category = kind === 'category';
      const attr = category ? 'data-category' : 'data-yarn-tab';
      const panel = category ? 'data-panel' : 'data-yarn-panel';
      this.querySelectorAll('[' + attr + ']').forEach(tab => {
        const active = tab.getAttribute(attr) === value;
        tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1;
      });
      this.querySelectorAll('[' + panel + ']').forEach(item => { item.hidden = item.getAttribute(panel) !== value; });
      if (this.main) this.main.scrollTop = 0;
    }
    resize() {
      const top = this.getBoundingClientRect().top;
      this.style.setProperty('--cf-catalog-max-height', Math.max(180, window.innerHeight - top - 16) + 'px');
    }
    close() { this.disclosure.open = false; this.disclosure.querySelector('summary').focus(); }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}
  } catch(e) { console.error(e); }
})();

})();
